module.exports = __webpack_public_path__ + "static/media/6.Garden Pipes.9aa3989e.jpg";